import {Box, Stack, Typography} from '@mui/material';
import React from 'react';
import {
  AllowedPlayerTypeKeys,
  ListPlayerTypeBased,
} from '../stepperComponents/SongMappingStepperCmpt';
import {INewWalkupPlayer} from '../stepperComponents/WalkupLineupStepper';

export interface PlayerSelectionPanelProps {
  selectedPlayerType: AllowedPlayerTypeKeys;
  setSelectedPlayerType: React.Dispatch<
    React.SetStateAction<AllowedPlayerTypeKeys>
  >;
  playerId: number;
  setPlayerId: React.Dispatch<React.SetStateAction<number>>;
  players: INewWalkupPlayer[];
  isAthlete: boolean;
  isStudentForm?: boolean;
}

export const PlayerSelectionPanel = React.memo<PlayerSelectionPanelProps>(
  ({
    selectedPlayerType,
    setSelectedPlayerType,
    playerId,
    setPlayerId,
    players,
    isAthlete,
    isStudentForm = true,
  }) => {
    return (
      <>
        <Box className='py-4 h-60'>
          <Typography variant='h6' className='text-center font-bold'>
            Select Player
          </Typography>
        </Box>
        <Box
          className='flex-column scrollbar h-full overflow-auto'
          style={{ maxHeight: 'calc(100% - 80px)' }}>
          {isAthlete ? (
            <ListPlayerTypeBased
              selectedPlayerType={selectedPlayerType}
              setSelectedPlayerType={setSelectedPlayerType}
              playerId={playerId}
              setPlayerId={setPlayerId}
              players={players}
              playerType='athlete'
              isStudentForm={isStudentForm}
            />
          ) : (
            <Stack spacing={2} sx={{height: '100%', gap: 1}}>
              <ListPlayerTypeBased
                selectedPlayerType={selectedPlayerType}
                setSelectedPlayerType={setSelectedPlayerType}
                playerId={playerId}
                setPlayerId={setPlayerId}
                players={players}
                playerType='hitter'
                isStudentForm={isStudentForm}
              />
              <ListPlayerTypeBased
                selectedPlayerType={selectedPlayerType}
                setSelectedPlayerType={setSelectedPlayerType}
                playerId={playerId}
                setPlayerId={setPlayerId}
                players={players}
                playerType='pitcher'
                isStudentForm={isStudentForm}
              />
            </Stack>
          )}
        </Box>
      </>
    );
  },
);

PlayerSelectionPanel.displayName = 'PlayerSelectionPanel';
